import React, { useEffect, useState } from 'react'
// import Calendar from '../../elements/Calendar'
import FeedbackCard from '../../elements/FeedbackCard'
// import TrophyIcon from '../../elements/icons/TrophyIcon'
import { authHeader } from '../../../utils'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import StudentSubjectCard from '../../elements/StudentSubjectCard'
import ExeatTypePill from '../../elements/ExeatTypePill'
import moment from 'moment'
import DisciplinaryRecordCard from '../../elements/cards/DisciplinaryRecordCard'
import Loader from '../../elements/Loader'

const StudentOverview = ({student}) => {

  const [activeSubjectIndex, setActiveSubjectIndex] = useState(null);

  const [overviewData, setOverviewData] = useState(null)
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchStudentOverviewData = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboards/students/${student._id}`, { headers })            
          setOverviewData(response.data.data)
          setLoading(false)
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setLoading(false)
        }
    }

    fetchStudentOverviewData()
  
    return () => {
      
    }
  }, [dispatch, student._id])
  

  return (
    <>
      {loading ?

        <Loader />
        :
        <div>
          <div className='w-full xl:flex items-start justify-between gap-x-[10px]'>
            {/* LEFT */}
            <div className='w-full xl:w-9/12'>

              <div className='w-full grid grid-cols-1 xl:grid-cols-3 gap-[10px]'>
                <div className='w-full p-[20px] rounded border border-gray-200'>
                  <p className='text-sm text-gray-500 pb-[20px] border-b border-gray-300'>Sundry Account</p>
                  <p className='text-xs text-gray-500 mb-[5px] mt-[10px]'>Sundry Balance</p>
                  <h3 className='font-space-grotesk text-2xl font-medium text-vcm-purple'>N{(overviewData?.sundry?.balance/100)?.toLocaleString()}</h3>
                  <p className='text-[13px]'>{overviewData?.sundry?.transactions || 0} sundry transactions</p>
                </div>
                <div className='w-full p-[20px] rounded border border-gray-200'>
                  <p className='text-sm text-gray-500 pb-[20px] border-b border-gray-300'>Pending Invoices</p>
                  <p className='text-xs text-gray-500 mb-[5px] mt-[10px]'>Amount due</p>
                  <h3 className='font-space-grotesk text-2xl font-medium text-vcm-purple'>N{(overviewData?.invoices[0]?.discountedTotal/100 || 0)?.toLocaleString()}</h3>
                  <p className='text-[13px]'>from 1 assigned invoice</p>
                </div>
                <div className='w-full p-[20px] rounded border border-gray-200'>
                  <p className='text-sm text-gray-500 pb-[20px] border-b border-gray-300'>Current Exeat</p>
                  <div className='mt-[10px]'>
                    <ExeatTypePill type={overviewData?.exeat?.reasonType} />
                  </div>
                  
                  {/* <p className='text-xs text-gray-500 mb-[5px] mt-[10px]'>Pickup date</p> */}
                  <p className='text-[13px] mt-[10px] text-gray-500'>From <span className='text-gray-900 font-space-grotesk'>{moment(overviewData?.exeat?.dates?.from).format('dddd, DD/MM/YYYY')}</span> to <span className='text-gray-900 font-space-grotesk'>{moment(overviewData?.exeat?.dates?.to).format('dddd, DD/MM/YYYY')}</span></p>

                </div>
              </div>

              <div className='w-full flex items-center justify-between py-2 mt-[10px] mb-2 border-b'>
                <p className='text-[15px] font-medium font-space-grotesk text-gray-600'>Academic performance <span className="lg:hidden text-xs font-outfit text-gray-400">(Tap a bar for details)</span></p>
              </div>

              <div className='w-full flex items-start gap-x-2'>
                {/* Y-axis labels */}
                <div className='lg:flex flex-col justify-between hidden h-[300px] pt-1 pb-1'>
                  <span className='text-xs text-gray-600'>100%</span>
                  <span className='text-xs text-gray-600'>80%</span>
                  <span className='text-xs text-gray-600'>60%</span>
                  <span className='text-xs text-gray-600'>40%</span>
                  <span className='text-xs text-gray-600'>20%</span>
                  <span className='text-xs text-gray-600'>0%</span>
                </div>

                {/* Chart container with bars and labels */}
                <div className='flex-1'>
                  {/* Bar chart */}
                  <div className='w-full flex items-end justify-between h-[300px] relative'>
                    {overviewData?.subjectAverages?.map((subject, subjectIndex)=>(
                      <div key={subjectIndex} onMouseEnter={()=>{setActiveSubjectIndex(subjectIndex)}} onMouseOut={()=>{setActiveSubjectIndex(null)}} className={`relative cursor-pointer transition duration-200 rounded w-[5px] lg:w-[10px] xl:w-[40px] bg-vcm-purple z-50`} style={{minHeight: '1%', height: subject.averageScore + '%'}}>
                        {activeSubjectIndex === subjectIndex && <div className='transition duration-200 w-[200px] p-[10px] bg-vcm-light-purple -left-[75px] bottom-[100px] absolute'>
                          <label className='block text-xs mb-[5px]'>Subject</label>
                          <p className='text-sm font-medium mb-[10px]'>{subject.subject.name}</p>

                          <label className='block text-xs mb-[5px]'>Average score</label>
                          <p className='text-sm font-medium mb-[10px]'>{subject.averageScore.toFixed(2)}%</p>
                        </div>}
                      </div>
                    ))}
                  </div>
                  
                  {/* X-axis labels (subject names) */}
                  <div className='w-full hidden lg:flex items-start justify-between mt-2'>
                    {overviewData?.subjectAverages?.map((subject, subjectIndex)=>(
                      <div key={subjectIndex} className='w-[10px] xl:w-[40px] flex items-center justify-center'>
                        <p className='text-[10px] xl:text-xs text-gray-600 text-center transform -rotate-45 origin-top-left xl:rotate-0 whitespace-nowrap'>
                          {subject.subject.name.length > 6 ? subject.subject.name.substring(0, 6) + '...' : subject.subject.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>

            {/* RIGHT */}
            <div className='w-full xl:w-3/12 mt-[20px] xl:mt-0'>
                <div className='w-full rounded p-[20px] border border-gray-200'>
                  <p className='text-sm text-gray-500'>Overall academic average</p>
                  <h1 className='font-space-grotesk text-3xl font-medium my-[10px] text-vcm-purple'>{overviewData?.overallAverage?.toFixed(2) || 0}<span className='text-[15px]'>%</span></h1>
                  <p className='text-xs text-gray-500'>This is the percentage average score from all assessments taken by this student</p>

                </div>

                <div className='mt-[25px]'>
                  <h3 className='font-space-grotesk text-[14px] text-gray-600 font-medium mb-2.5 px-2'>Highest Performing Subject</h3>
                  {overviewData?.highestPerformingSubject &&
                    <StudentSubjectCard 
                      subject={overviewData?.highestPerformingSubject.subject} 
                      student={student} 
                      hideTeacher
                      additionalInfo={<p className='text-[13px] text-gray-500'>from {overviewData?.highestPerformingSubject?.assessmentCount} assessments with an average score of {overviewData?.highestPerformingSubject?.averageScore?.toFixed(2) || 0}%</p>}
                    />}
                </div>            
                
                <div className='mt-[25px]'>
                  <h3 className='font-space-grotesk text-[14px] text-gray-600 font-medium mb-2.5 px-2'>Poorest Performing Subject</h3>
                  {overviewData?.poorestPerformingSubject &&
                    <StudentSubjectCard 
                      subject={overviewData?.poorestPerformingSubject.subject} 
                      student={student} 
                      hideTeacher
                      additionalInfo={<p className='text-[13px] text-gray-500'>from {overviewData?.poorestPerformingSubject?.assessmentCount} assessments with an average score of {overviewData?.poorestPerformingSubject?.averageScore?.toFixed(2) || 0}%</p>}
                    />}
                </div>
            </div>
          </div>

          <div className='w-full xl:flex items-start justify-between gap-x-8 mt-[20px]'>
            {/* LEFT */}
            <div className='w-full'>
              <div className='w-full'>
                <div className='w-full flex items-center justify-between py-2 mb-2 border-b'>
                  <p className='font-space-grotesk text-[15px] text-gray-600 font-medium'>Student disciplinary records</p>
                </div>
                
                {overviewData?.disciplinaryRecords?.map((item, index) => (
                  <DisciplinaryRecordCard key={index} record={item} />
                ))}
              </div>
            </div>

            {/* RIGHT */}
            <div className='w-full mt-[20px] xl:mt-0'>
              <div className='w-full'>
                <div className='w-full flex items-center justify-between py-2 mb-2 border-b'>
                  <p className='font-space-grotesk text-[15px] text-gray-600 font-medium'>Student feedback</p>
                </div>
                
                {overviewData?.feedback?.map((item, index) => (
                  <FeedbackCard key={index} item={item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default StudentOverview